/**
 * @author       sarah.walloga@zumper.com (Sarah Walloga)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  isServer.ts
 */

// We're "on server" when we have platform but not window.
// - Node (and electron, and react-native, etc) define a global process object
// - Jest-DOM runs within node but makes a `window` object available
export let IS_SERVER =
  typeof process !== 'undefined' &&
  Boolean(process.platform) &&
  typeof window === 'undefined'

/* istanbul ignore next */
export const mockIsServer = (status: boolean) => {
  IS_SERVER = status
}
